import React, {Component} from "react";
import config from 'react-global-configuration';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import Stepper from 'react-stepper-horizontal';
import axios from "axios";
import $ from 'jquery';
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import CommonNavbar, {navbar} from "./commonNavbar";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;


class Communication extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emiMenus:[],
            stepsBrand: [{
                    title: '',

                  }, {
                    title: '',

                  }, {
                    title: '',
                    }
                ],
            stepsMerchant: [{
                title: '',

                }
            ],
            currentStepBrand: 0,
            currentStepMerch: 0,
            merchproduct: 0,
            brandproduct: 0,
            brandscheme: 0,
            brandpromotion: 0

        };

    }
    componentDidMount() {
        this.checkAdmin();
    }

    checkAdmin(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if (decoded.userGroup == 1 || decoded.userGroup == '1'){
            this.props.history.push('/admin/manage-communication');
        }
    }

    render() {
        return(<div></div>);
    }
}

export default Communication;